import { Injectable } from '@angular/core';
import { SecureApi } from '../core/secure.api';

@Injectable()
export class TemplatesService {
    constructor(public secureApi: SecureApi) {
    }

    all() {
        return this.secureApi.get('templates/index');
    }

    getByClinic(clinicId){
        return this.secureApi.get('templates/clinic/' + clinicId);
    }
    /**
     * @param templateId
     * @param languageCode
     * @param {string} clinicId
     * @returns {Observable<any>}
     */
    read(templateId, languageCode, clinicId = '') {
        if (!templateId || !languageCode) {
            return;
        }

        return this.secureApi.get('templates/read/' + templateId + '/' + languageCode + '/' + clinicId)
            ;
    }

    /**
     * @param templateTranslationId
     * @param emailTemplateForm
     * @param emailTemplateModel
     * @returns {Observable<any>}
     */
    save(templateTranslationId, emailTemplateForm, emailTemplateModel) {
        if (!templateTranslationId) {
            return;
        }

        let url = 'template-translation/update/' + templateTranslationId;

        emailTemplateForm.customized = (emailTemplateForm.title !== emailTemplateModel.original_title);

        if (emailTemplateForm.content !== emailTemplateModel.original_content
            || emailTemplateForm.add_disclaimer != emailTemplateModel.origin_add_disclaimer
            || emailTemplateForm.disclaimer_text != emailTemplateModel.origin_disclaimer_text
            || emailTemplateForm.email_subject != emailTemplateModel.origin_email_subject
            ) {
            emailTemplateForm.customized = true;
        }

        emailTemplateForm.add_disclaimer = emailTemplateModel['add_disclaimer'];

        return this.secureApi.post(url, emailTemplateForm, false);
    }

    /**
     * Search template content
     *
     * @param {string} searchTerm
     * @returns {Observable<any>}
     */
    search(searchTerm: string, clinicId : number) {
        if (!searchTerm) {
            return;
        }

        let sanitizeSearchTerm = encodeURIComponent(searchTerm);
        return this.secureApi.get('templates/search/' + sanitizeSearchTerm + '/' + clinicId);
    }

    /**
     * Revert, reset default template, only admin of clinic can do it
     * @returns {Observable<any>}
     */
    revertToDefaultTemplate(emailTemplate) {
        let url = 'template-translation/revert/' + emailTemplate.id;

        return this.secureApi.post(url, emailTemplate, false);
    }
}
